import { useEffect, useState } from 'react';

export const useAlternatingText = (texts: string[], intervalMs: number, isActive: boolean): string => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!isActive) {
      setIndex(0);
      return;
    }

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, intervalMs);

    return (): void => clearInterval(timer);
  }, [isActive, intervalMs, texts.length]);

  return texts[index] ?? texts[0] ?? '';
};
